// Carte d'article reutilisable

import { Link } from "react-router-dom";
import { Clock, Calendar } from "lucide-react";
import { Article, categoryColors, formatArticleDate } from "@/data/articles";

interface BlogCardProps {
  article: Article;
}

const BlogCard = ({ article }: BlogCardProps) => {
  return (
    <Link
      to={`/blog/${article.slug}`}
      className="group block rounded-2xl p-[1px] bg-gradient-to-b from-white/[0.08] to-transparent hover:from-[#F59E0B]/30 hover:to-transparent transition-all duration-300"
    >
      <div className="h-full rounded-2xl bg-[#1E293B]/80 backdrop-blur-sm overflow-hidden flex flex-col">
        {/* Image placeholder */}
        <div className="aspect-video bg-gradient-to-br from-[#0F172A] to-[#1E293B] relative overflow-hidden">
          {article.image ? (
            <img
              src={article.image}
              alt={article.title}
              loading="lazy"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-14 h-14 rounded-[12px] bg-[#131318] border border-white/[0.06] flex items-center justify-center">
                <svg className="w-6 h-6 text-white/50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" x2="8" y1="13" y2="13"/><line x1="16" x2="8" y1="17" y2="17"/>
                </svg>
              </div>
            </div>
          )}

          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#1E293B] via-transparent to-transparent" />
        </div>

        {/* Content */}
        <div className="p-5 flex-1 flex flex-col">
          {/* Badge categorie */}
          <span className={`inline-flex self-start px-3 py-1 rounded-full text-xs font-medium border ${categoryColors[article.category]}`}>
            {article.category}
          </span>

          {/* Titre */}
          <h3 className="mt-3 text-lg font-semibold text-white group-hover:text-[#F59E0B] transition-colors line-clamp-2">
            {article.title}
          </h3>

          {/* Extrait */}
          <p className="mt-2 text-sm text-white/50 line-clamp-2 flex-1">
            {article.excerpt}
          </p>

          {/* Footer */}
          <div className="mt-4 pt-4 border-t border-white/[0.05] flex items-center gap-4 text-xs text-white/40">
            <span className="flex items-center gap-1.5">
              <Calendar className="w-3.5 h-3.5" />
              {formatArticleDate(article.publishedAt)}
            </span>
            <span className="flex items-center gap-1.5">
              <Clock className="w-3.5 h-3.5" />
              {article.readingTime} min
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
